module.exports = __webpack_public_path__ + "static/media/u21a-c_f3.6fba8701.mp3";